import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { Auth } from '@app/interfaces/sys/auth';
import { SelectOption } from '@app/interfaces/sys/dict';
import { TokenService } from '@services/sys/token.service';

@Component({
  selector: 'app-filter-member',
  templateUrl: './filter-member.component.html',
  styleUrl: './filter-member.component.less'
})
export class FilterMemberComponent implements OnChanges {
  @Input() filterListInput: any;
  @Input() members: SelectOption[] = []; // List of all members, including "unassigned" members.
  @Input() maxVisibleAvatars = 6; // Max avatars to display
  @Output() memberFilterChanged = new EventEmitter<SelectOption[]>(); // Emit updated filter list
  userInfo!: Auth;
  filterList: SelectOption[] = []; // Keep track of selected members.
  timer: number | null = null;
  colorArr: {
    [key: string]: string
  } = {
      A: '#125082',
      B: '#3a0e72',
      C: '#640646',
      D: '#095417',
      E: '#544609',
      F: '#366d1b',
      G: '#BD5FFC',
      H: '#FC5F77',
      I: '#23f7ee',
      J: '#0A6D3A',
      K: '#6B2EAD',
      L: '#DA2F15',
      M: '#80aa65',
      N: '#AAFF56',
      O: '#6c4d63',
      P: '#FFDEAD',
      Q: '#c7ed98',
      R: '#8AC153',
      S: '#214c9c',
      T: '#8893b8',
      U: '#216ae3',
      V: '#e9d2ca',
      W: '#bbc730',
      X: '#473C9D',
      Y: '#e0aff7',
      Z: '#007B52',
    };
    filterText = '';
    defaultFliterMembers: SelectOption[] = [];
    fliterMembers: SelectOption[] = [];

  constructor(
    private tokenService: TokenService) {
  }

  isMemberActive(member: SelectOption): boolean {
    if (member.info) {
      return member.info.enable;
    }
    return member.enable ?? true;
  }

  reorderMembers() {
    if(this.members.length === 0) {
      return;
    }
    const ownerId = this.userInfo.id;
    const ownerIndex = this.members.findIndex(member => member.value === ownerId);

    if (ownerIndex !== -1) {
      const owner = this.members.splice(ownerIndex, 1)[0];
      this.members.unshift(owner);
    }
  }

  // Toggle member selection for filtering
  toggleMemberSelection(member: SelectOption): void {
      console.log('toggleMemberSelection');
    const index = this.filterList.indexOf(member);
    if (index > -1) {
      this.filterList.splice(index, 1); // Remove if already selected
    } else {
      this.filterList.push(member); // Add to filter if not selected
    }
    if (this.timer) {
      clearTimeout(this.timer);
    }
    this.timer = window.setTimeout(() => {
      this.memberFilterChanged.emit(this.filterList); // Emit updated list
    }, 500);
  }

  clearSelection(): void {
    this.filterList = [];
    this.members.forEach(member => member.checked = false);
  }

  ngOnChanges(changes: SimpleChanges): void {
    this.userInfo = this.tokenService.get();
    this.reorderMembers();
    const fliterMembers = this.getDropdownMembers();
    this.defaultFliterMembers = fliterMembers;
    this.fliterMembers = fliterMembers;
    // 外部赋值时同步filterList和checked
    if (changes['filterListInput']) {
      const newVal = changes['filterListInput'].currentValue;
      this.filterList = newVal ? [...newVal] : [];
      // 同步checked状态
      if (this.fliterMembers) {
        this.fliterMembers.forEach(member => {
          member.checked = this.filterList.some(sel => sel.value === member.value);
        });
      }
      if (this.members) {
        this.members.forEach(member => {
          member.checked = this.filterList.some(sel => sel.value === member.value);
        });
      }
    }
    if (this.filterList && this.fliterMembers) {
      this.fliterMembers.forEach(member => {
        member.checked = this.filterList.some(sel => sel.value === member.value);
      });
    }
    if (this.filterList && this.members) {
      this.members.forEach(member => {
        member.checked = this.filterList.some(sel => sel.value === member.value);
      });
    }
    const { members } = changes;
    if (members && this.filterList.length > 0) {
      const memberIds = (this.members || []).map(it => it.value as number);
      if (this.filterList.every(it => memberIds.includes(it.value as number))) {
        return;
      }
      this.filterList = this.filterList.filter(it => memberIds.includes(it.value as number));
      this.memberFilterChanged.emit(this.filterList); // Emit updated list
    }
  }

  // Checks if a member is selected
  isSelected(member: SelectOption): boolean {
    return this.filterList.includes(member);
  }

  // Generate a background color based on the first letter of the member's name
  getBackgroundColor(name: string): string {
    const firstCode = name.slice(0, 1).toUpperCase();
    const charCode = this.colorArr[firstCode];
    return charCode;
  }

  fliterMember() {
    if (!this.filterText) {
      this.fliterMembers = [...this.defaultFliterMembers];
    }
    else {
      const filteredMembers = this.defaultFliterMembers.filter(member =>
        member.label.toLowerCase().includes(this.filterText.toLowerCase())
      );
      this.fliterMembers = [...filteredMembers];
    }
  }

  // Get the members for the dropdown (excluding the first few visible avatars)
  getDropdownMembers(): SelectOption[] {
    return this.members.slice(this.maxVisibleAvatars);
  }

  isDropdownSelected(): boolean {
    // Check if any members in the dropdown list (beyond the visible ones) are selected
    return this.members.slice(this.maxVisibleAvatars).some(member => member.checked);
  }
}
